module.exports = __webpack_public_path__ + "img/Bodice-Front-B5-Jbcd.d24938d1.png";